import { render, staticRenderFns } from "./ProfilePhotoLayout.vue?vue&type=template&id=36e6162e&"
import script from "./ProfilePhotoLayout.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports